// Faroese translations
export const fo: Record<string, string> = {
  'menu.dashboard': 'Stýriborð',
  'menu.customers': 'Kundar',
  'menu.products': 'Vørur',
  'menu.users': 'Brúkarar',
  'menu.settings': 'Stillingar',
  'menu.logout': 'Rita út',
  'dashboard.title': 'Stýriborð',
  'dashboard.newOrder': 'Nýggj pøntun',
  'order.title': 'Nýggj pøntun',
  'order.customer': 'Kundi',
  'order.products': 'Vørur',
  'order.total': 'Tilsamans',
  'users.title': 'Brúkarar',
  'users.name': 'Navn',
  'users.email': 'Teldupostur',
  'common.yes': 'Ja',
  'common.no': 'Nei',
  'common.cancel': 'Angra',
  'common.save': 'Goym',
  'common.search': 'Leita',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Rita inn',
  'login.welcome': 'Vælkomin, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Teldupostur',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Frágreiðingar og roknskapur',
  'menu.systemAndCommunication': 'Kervi og samskifti',
};